var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { YU_COLOURS } from "../../../..";
export var Chevron = function (_a) {
    var className = _a.className, _b = _a.width, width = _b === void 0 ? "1rem" : _b, _c = _a.height, height = _c === void 0 ? "1rem" : _c, _d = _a.fill, fill = _d === void 0 ? YU_COLOURS.stone.B1100 : _d, title = _a.title, direction = _a.direction;
    return (React.createElement(Svg, { className: className, width: width, height: height, viewBox: "0 0 16 16", fill: "none", direction: direction, xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("title", null, title),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.86201 13.8047C4.60166 13.5444 4.60166 13.1223 4.86201 12.8619L9.72394 8L4.86201 3.13807C4.60166 2.87772 4.60166 2.45561 4.86201 2.19526C5.12236 1.93491 5.54447 1.93491 5.80482 2.19526L11.1382 7.5286C11.3985 7.78895 11.3985 8.21106 11.1382 8.47141L5.80482 13.8047C5.54447 14.0651 5.12236 14.0651 4.86201 13.8047Z", fill: fill })));
};
var getDirection = function (direction) {
    if (direction === "top") {
        return "270deg";
    }
    if (direction === "bottom") {
        return "90deg";
    }
    if (direction === "left") {
        return "180deg";
    }
    return "0deg";
};
var Svg = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transform: rotate(", ");\n"], ["\n  transform: rotate(", ");\n"])), function (_a) {
    var direction = _a.direction;
    return getDirection(direction);
});
var templateObject_1;
